import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPocketComponent } from './simple-icons-pocket.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPocketComponent ],
    exports:      [ SimpleIconsPocketComponent ],
    bootstrap:    []
})
export class SimpleIconsPocketModule {}
